import React, { useMemo } from 'react'
import classNames from 'classnames'
import ReactModal from 'react-modal'
import Modal from '../../atoms/modal/Modal'

import './StandardModal.scss'
import Icon from '../../atoms/icon/Icon'
import Theme from '../../../styles/_theme.module.scss'

interface Props {
  isOpen: boolean
  isMinimal?: boolean
  isScrollable?: boolean
  size: 'small' | 'medium' | 'large' | 'scale'
  onClose: () => void
  showCloseButton?: boolean
  className?: string
  'data-test'?: string
}

const simpleModalOverride: ReactModal.Styles = {
  content: {
    overflow: 'visible'
  }
}

const SimpleModal: React.FC<Props> = ({
  isOpen,
  size,
  isMinimal = false,
  showCloseButton = false,
  isScrollable = false,
  onClose,
  className,
  children,
  ...props
}) => {
  const overrides = useMemo(() => {
    if (isMinimal) {
      return {
        content: {
          ...simpleModalOverride.content,
          background: 'none'
        }
      }
    }
    if (size === 'scale') {
      return {
        content: {
          ...simpleModalOverride.content,
          width: '95%'
        }
      }
    }
    return simpleModalOverride
  }, [isMinimal, size])
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overrideStyles={overrides}
    >
      <div data-test={props['data-test']}>
        <div className={classNames('standard-modal-body', `size-${size}`, className, {
          showCloseButton,
          minimal: isMinimal,
          scrollable: isScrollable
        })}>
          {children}
        </div>
        {showCloseButton && <button
          className={classNames('close-button')}
          onClick={onClose}
          aria-label="Close">
          <Icon type='close' fill={Theme.white} className="m-0" />
        </button>}
      </div>
    </Modal>
  )
}


export default SimpleModal
